define([], function() {
		/**
	 * Detects Chrome browser
	 * @param {string} userAgent
	 * @return {boolean}
	 */
	function isChrome(userAgent) {
		return /Chrome/i.test(userAgent) &&
			!/Chromium/i.test(userAgent) &&
			!/OPR/i.test(userAgent) &&
			!isEdge(userAgent) &&
			!isEdgeLegacy(userAgent) &&
			!/SamsungBrowser/i.test(userAgent);
	}

	/**
	 * Detects Safari browser
	 * @param {string} userAgent
	 * @return {boolean}
	 */
	function isSafari(userAgent) {
		return (/Safari/i.test(userAgent) || /AppleWebKit/i.test(userAgent)) &&
			!/Chrome/i.test(userAgent) &&
			!/Chromium/i.test(userAgent) &&
			!/Android/i.test(userAgent);
	}

	/**
	 * Detects UC browser
	 * @param {string} userAgent
	 * @return {boolean}
	 */
	function isUCBrowser(userAgent) {
		return /UCBrowser/i.test(userAgent);
	}

	/**
	 * Detects Firefox browser
	 * @param {string} userAgent
	 * @return {boolean}
	 */
	function isFirefox(userAgent) {
		return /Firefox/i.test(userAgent) && !/Seamonkey/i.test(userAgent);
	}

	/**
	 * Detects IE browser
	 * @param {string} userAgent
	 * @return {boolean}
	 */
	function isIE(userAgent) {
		return (/trident/i.test(userAgent));
	}

	/**
	 * Detects Opera browser
	 * @param {string} userAgent
	 * @return {boolean}
	 */
	function isOpera(userAgent) {
		return /OPR/i.test(userAgent);
	}

	/**
	 * Detects Samsung browser
	 * @param {string} userAgent
	 * @return {boolean}
	 */
	function isSamsungInternet(userAgent) {
		return /SamsungBrowser/i.test(userAgent);
	}

	/**
	 * Detects Android browser
	 * @param {string} userAgent
	 * @return {boolean}
	 */
	function isAndroidBrowser(userAgent) {
		return /Android/i.test(userAgent) &&
			!/Chrome/i.test(userAgent) &&
			/AppleWebKit/i.test(userAgent);
	}

	/**
	 * Detects Edge browser
	 * @param {string} userAgent
	 * @return {boolean}
	 */
	function isEdge(userAgent) {
		return /Edg\//i.test(userAgent) && /Chrome/i.test(userAgent);
	}

	/**
	 * Detects Edge Legacy browser
	 * @param {string} userAgent
	 * @return {boolean}
	 */
	function isEdgeLegacy(userAgent) {
		return /Edge/i.test(userAgent) && /Chrome/i.test(userAgent);
	}

	/**
	 * Detects browser name
	 * @param {string} userAgent - window.navigator
	 * @return {string} browser name
	 */
	function detectBrowserName(userAgent) {
		if (isChrome(userAgent)) return 'Chrome';
		if (isSafari(userAgent)) return 'Safari';
		if (isUCBrowser(userAgent)) return 'UC Browser';
		if (isFirefox(userAgent)) return 'Firefox';
		if (isIE(userAgent)) return 'IE';
		if (isOpera(userAgent)) return 'Opera';
		if (isSamsungInternet(userAgent)) return 'Samsung Internet';
		if (isAndroidBrowser(userAgent)) return 'Android Browser';
		if (isEdge(userAgent)) return 'Edge';
		if (isEdgeLegacy(userAgent)) return 'Edge Legacy';
		return '';
	}

	function detectCurrentBrowserName() {
		return detectBrowserName(window.navigator.userAgent);
	}

	return {
		detectBrowserName: detectBrowserName,
		detectCurrentBrowserName: detectCurrentBrowserName
	};
});